import type { Storage } from "./types";

export class WebStorageAdapter {
  private storage: Storage | null;

  constructor(storage: Storage | null) {
    this.storage = storage;
  }

  getItem(key: string) {
    return this.storage?.getItem(key) || null;
  }

  setItem(key: string, value: string) {
    this.storage?.setItem(key, value);
  }

  removeItem(key: string) {
    this.storage?.removeItem(key);
  }

  clear() {
    this.storage?.clear();
  }
}
